/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueDate/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import NextAppointmentDate from './NextAppointmentDate/index'
import React from 'react'
import Today from './Today/index'
import TodayPlusDays from './TodayPlusDays/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DueDate({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/DueDate"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="DueDate.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-ZJrfN6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<NextAppointmentDate
  viewPath={`${viewPath}/NextAppointmentDate`}
/>
<Today
  viewPath={`${viewPath}/Today`}
/>
<TodayPlusDays
  viewPath={`${viewPath}/TodayPlusDays`}
/>
</div>
{children}
</React.Fragment>)
}